import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Alert } from '@mm/components';
import React from 'react';
import styles from './KlaviyoIntegrations.module.css';

export const KlaviyoOptInNotification = () => (
  <Alert
    type="info"
    showCloseIcon={false}
    hideLeftIcon={true}
    customStyle={true}
    leftIcon={<ExclamationCircleOutlined className={styles.optInNoteIcon} />}
    css={{
      container: styles.optInNoteContainer,
      text: styles.optInNoteText,
    }}
  >
    For seamless integration and to ensure incoming contacts are promptly added,
    please switch from Double Opt-In to Single Opt-In in{' '}
    <a
      className={styles.optInNoteLink}
      target="_blank"
      rel="noreferrer noopener"
      href="https://help.klaviyo.com/hc/en-us/articles/115005251108#enable-single-opt-in3"
    >
      Klaviyo settings
    </a>
    .
  </Alert>
);
